// Returns a customer's physical address formatted as a conventional mailing address.
interface AddressArguments {
  city?: string;
  line2?: string;
  state?: string;
  street?: string;
  zip?: string;
}

export const formatAddress = (physicalAddress: AddressArguments): string => {
  const { city, line2, state, street, zip } = physicalAddress;
  let addressStr = [street, line2, city, state, zip].filter((item) => item).join(', ');
  // Remove the comma between the state and ZIP code. See: https://stackoverflow.com/a/14355832/9027907
  if (zip) {
    addressStr = addressStr.replace(/,(?=[^,]*$)/, '');
  }
  return addressStr;
};
